import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import HiddenLoader from '@fuww/library/src/HiddenLoader';
import withQuery from '../../../lib/withQuery';
import JobLinks from './JobLinks';
import messages from '../../../lib/messages.mjs';
import latestJobsQuery from '../../../lib/queries/jobs/latestJobsQuery.graphql';
import { useSiteContext } from '../../SiteContext';

export const latestJobsImageUrls = {
  sidebar: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=28,quality=10,width=42/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=208,quality=70,width=311/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=307,quality=70,width=460/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=378,quality=70,width=567/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=438,quality=70,width=656/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=496,quality=70,width=744/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=614,quality=70,width=920/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=756,quality=70,width=1134/https://media.fashionunited.com/media/images/latestJobsImage.png',
  ],
  main: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=28,quality=10,width=42/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=220,quality=70,width=330/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=440,quality=70,width=660/https://media.fashionunited.com/media/images/latestJobsImage.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=480,quality=70,width=720/https://media.fashionunited.com/media/images/latestJobsImage.png',
  ],
};

const LatestJobs = ({
  data,
  title,
  categoryParam,
  placeholder,
  src,
  srcSet,
  sizes,
}) => {
  const intl = useIntl();

  return (
    <JobLinks
      title={title || intl.formatMessage(messages.latestJobs)}
      className="highlight"
      jobs={data.jobs}
      categoryParam={categoryParam}
      placeholder={placeholder}
      src={src}
      srcSet={srcSet}
      sizes={sizes}
    />
  );
};

LatestJobs.propTypes = {
  data: PropTypes.shape({
    jobs: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  title: PropTypes.string,
  categoryParam: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
};

LatestJobs.defaultProps = {
  data: {},
  title: null,
  categoryParam: null,
};

const LatestJobsWithQuery = withQuery(LatestJobs);

const LatestJobsWithData = ({
  variables,
  title,
  categoryParam,
  placeholder,
  src,
  srcSet,
  sizes,
}) => {
  const { jobsLocale } = useSiteContext();
  const mostReadVariables = {
    locales: jobsLocale,
    offset: 0,
    limit: 3,
    ...variables,
  };

  return (
    <LatestJobsWithQuery
      query={latestJobsQuery}
      variables={mostReadVariables}
      errorMessage="Error while loading jobs..."
      title={title}
      categoryParam={categoryParam}
      placeholder={placeholder}
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      loader={<HiddenLoader />}
    />
  );
};

LatestJobsWithData.propTypes = {
  variables: PropTypes.shape({}),
  title: PropTypes.string,
  categoryParam: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
  sizes: PropTypes.string.isRequired,
};

LatestJobsWithData.defaultProps = {
  variables: {},
  title: null,
  categoryParam: null,
};

export default LatestJobsWithData;
